import { IS_EMPTY, IS_NOT_EMPTY, IS_NOT_ONE_OF, IS_ONE_OF, TEXT_IS, TEXT_IS_NOT } from '../filter-conditions.js';
export const statusFilterConditions = [
    IS_ONE_OF,
    IS_NOT_ONE_OF,
    TEXT_IS,
    TEXT_IS_NOT,
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map